import Model from './Model';

class Feature extends Model {
  getFeatureId() {
    return this.attrs.featureId;
  }

  getFeatureName() {
    return this.attrs.featureName;
  }

  getLimits(value) {
    this.attrs.limits = value;
    return this;
  }

  getUnits(value) {
    this.attrs.units = value;
    return this;
  }
}

export default Feature;
